import React from 'react';
import { Tooltip, Popconfirm } from 'antd';
import {
  QuestionCircleOutlined,
  ShareAltOutlined,
  PlusOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { FacebookShareButton } from 'react-share';
import Button from '../../Button';
import Router from '../../../routes';
import Link from '../../Link';
import { LocalizationContext } from '../../../hoc/Localization';
import { EditorContext } from '../../../hoc/Editor';
import { RouteContext } from '../../../hoc/Route';
import { SettingsContext } from '../../../hoc/Settings';
import styles from '../styles.less';

const ToolBar = () => {
  const { edited, editMode, setEditMode, saveContent } = React.useContext(EditorContext);
  const { t } = React.useContext(LocalizationContext);
  const {
    page,
    params: { locale: pageLocale },
  } = React.useContext(RouteContext);

  const {
    domainSettings: { domain, locales },
  } = React.useContext(SettingsContext);

  const localesOptions = [
    {
      title: t('toolbar.language.default'),
      locale: 'default',
    },
    {
      title: t('frontpage.explore.second_question.1'),
      locale: 'en',
      flag: 'GB',
    },
    {
      title: t('frontpage.explore.second_question.7'),
      locale: 'hy',
      flag: 'AM',
    },
    {
      title: t('noresults.russian'),
      locale: 'ru',
      flag: 'RU',
    },
    {
      title: t('frontpage.explore.second_question.3'),
      locale: 'de',
      flag: 'DE',
    },
  ];

  localesOptions.forEach((option, index) => {
    if (option.locale !== 'default' && !locales.includes(option.locale)) {
      localesOptions.splice(index, 1);
    }
  });

  return editMode ? (
    <div className="editor-toolbar">
      <>
        <span className="helpArticle">
          <Link route="blogLanding" locale={pageLocale} url="how-to-create-course" target="blank">
            <QuestionCircleOutlined className="needHelp" />
            {t('course.edit.help')}
          </Link>
        </span>
        <div className="mobile-toolbar">
          {page === 'course' && (
            <div className={styles.courseSaveButton}>
              <Popconfirm
                title={`${t('course.copy.message')}`}
                okText={`${t('addschool.confirm.yes')}`}
                cancelText={`${t('addschool.confirm.no')}`}
                onConfirm={() => saveContent('copy')}
              >
                <Button type="primary" className="copyButton">
                  {t('course.edit.copy')}
                </Button>
              </Popconfirm>
            </div>
          )}
          <div className={styles.courseSaveButton}>
            <Button type="primary" onClick={saveContent} data_gh="course_edit_save">
              {t('course.edit.save')}
            </Button>
          </div>
        </div>
      </>
    </div>
  ) : (
      <div className="editButtonsContainer">
        {page === 'course' &&
          !!edited &&
          !!Object.keys(edited).length &&
          !!edited.school &&
          !!Object.keys(edited.school).length && (
            <FacebookShareButton
              url={`https://${domain === 'course.am' ? `www.${domain}` : domain
                }/${pageLocale}/courses/${edited.school.link}/${edited.link}/${edited.shortId}`}
            >
              <Tooltip title={t('course.share.tooltip')} placement="bottom">
                <Button type="primary" className="editShareButton">
                  <ShareAltOutlined />
                  <span>{t('school.edit.toolbar.share')}</span>
                </Button>
              </Tooltip>
            </FacebookShareButton>
          )}
        {page === 'school' && (
          <div
            className="editButton editModeButton toolBarButton"
            onClick={() => {
              Router.pushRoute('createCourse', {
                school: edited.shortId,
                locale: pageLocale,
              });
            }}
          >
            <PlusOutlined />
            <span>{t('details.edit.courses.add')}</span>
          </div>
        )}
        <Button
          type="secondary"
          className="editButton editModeButton toolBarButton"
          onClick={() => {
            setEditMode(true);
          }}
        >
          <EditOutlined />
          <span>{t('course.edit.title')}</span>
        </Button>
      </div>
    );
};

ToolBar.propTypes = {};

export default ToolBar;
